// extracted by mini-css-extract-plugin
module.exports = {"features":"hera-page-features_features__CWnZq","features_inner":"hera-page-features_features_inner__yjXDW","features_title":"hera-page-features_features_title__9ya89"};